var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.permission.user_edit)?_c('div',{on:{"click":function($event){return _vm.goToDetail()}}},[_c('u',{staticClass:"detail"},[_vm._v("ดูรายละเอียด")])]):_c('div',[_c('u',{staticClass:"no-detail"},[_vm._v("ดูรายละเอียด")])])}
var staticRenderFns = []

export { render, staticRenderFns }